import { inject } from "vue"
import { ToastScope } from "@/components/ui/Toast/ToastScope"
import { ToastInjectionKey } from "@/symbols"

export function useToast() {
  const scope = inject(ToastInjectionKey, new ToastScope(), true)

  return {
    scope,
  }
}
